<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false" on-slide-changed="slideChange($index)">

      <slide>
        <div class="padding">
          <p fade-click="lookagain" speed="normal">
            the next day I looked at the book again, thinking it would make more sense, that the things that feel like dreams would become actual memories. I read what looks like a poem, it's structure feels so natural. but the page is <a href="#"> wrong </a>
          </p>
          <p>
            yesterday this page was blank<br>
          </p>
          <p> &nbsp;</p>
          <p> &nbsp;</p>
        </div>
      </slide>

    </carousel>
  </div>
</template>

<script>
export default {

  name: '3',

  data () {
    return {
      title: 'Look Again'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
